import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';

const Perfil = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [modoEdicion, setModoEdicion] = useState(false);
  const [formulario, setFormulario] = useState({
    uid: user?.uid || '',
    nombres: '',
    apellidos: '',
    rut: '',
    correo: user?.email || '',
    celular: '',
    t_emergencia: '',
  });


  const [formularioOriginal, setFormularioOriginal] = useState(null);
  const [mensaje, setMensaje] = useState('');

  const esLoginConCorreo = user?.providerData?.[0]?.providerId === 'password';

  const campoIdentidadBloqueado = (campo) => {
    if (!formularioOriginal) return false;
    const valor = formularioOriginal[campo];
    return valor != null && String(valor).trim() !== '';
  };

  // ===========================
  // Cargar datos desde Firestore
  // ===========================
useEffect(() => {
  const cargar = async () => {
    if (!user?.email) return;

    const ref = doc(db, 'usuarios', user.email);
    const snap = await getDoc(ref);

    if (snap.exists()) {
      const d = snap.data();

      const limpio = {
        uid: user.uid,
        correo: user.email,
        nombres: d.nombres || '',
        apellidos: d.apellidos || '',
        rut: d.rut || '',
        celular: d.celular || '',
        t_emergencia: d.t_emergencia || '',
      };

      setFormulario(limpio);
      setFormularioOriginal(limpio);
    }
  };

  cargar();
}, [user]);


  // ===========================
  // Handlers
  // ===========================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormulario((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ref = doc(db, 'usuarios', user.email);

  const datos = {
    uid: user.uid,
    correo: user.email?.toLowerCase().trim() || "",
    nombres: (formulario.nombres || "").trim(),
    apellidos: (formulario.apellidos || "").trim(),
    rut: (formulario.rut || "").trim(),
    celular: (formulario.celular || "").trim(),
    t_emergencia: (formulario.t_emergencia || "").trim(),
  };

    await setDoc(ref, datos, { merge: true });

    setMensaje('Perfil actualizado correctamente');
    setModoEdicion(false);
    setFormularioOriginal(datos);
    setTimeout(() => setMensaje(''), 3000);
  };

  const handleCancelar = () => {
    setFormulario(formularioOriginal);
    setModoEdicion(false);
  };

  const handleCambiarContraseña = () => {
    navigate('/recuperar');
  };

  // ===========================
  // Render Helper
  // ===========================
  const renderInput = ({
    label,
    name,
    type = 'text',
    placeholder = '',
    readOnly = false,
  }) => (
    <div className="flex flex-col">
      <label className="text-[#0A1440] text-sm font-semibold mb-1">{label}</label>

      {modoEdicion && !readOnly ? (
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={formulario[name] || ''}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
          focus:ring-2 focus:ring-[#3A6AFF] focus:outline-none"
        />
      ) : (
        <p className="px-4 py-3 rounded-xl bg-gray-100 border border-gray-200">
          {formulario[name] || '-'}
        </p>
      )}
    </div>
  );


  // ===========================
  // JSX (diseño estilo Registro.jsx)
  // ===========================
  return (
    <div
      className="min-h-screen flex items-start justify-center px-6 pb-20"
      style={{
        background: 'linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)',
      }}
    >
      <div className="w-full max-w-3xl bg-white/60 backdrop-blur-xl rounded-3xl 
        shadow-[0_18px_50px_-10px_rgba(58,106,255,0.25)] ring-1 ring-white/30 p-8 mt-20">

        <h1 className="text-3xl font-extrabold text-center text-[#0A1440] mb-6">
          Mi Perfil
        </h1>

        {mensaje && (
          <div className="mb-4 p-3 rounded-xl bg-green-100 text-green-700 text-center">
            {mensaje}
          </div>
        )}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {renderInput({ label: 'Nombres', name: 'nombres' })}
          {renderInput({ label: 'Apellidos', name: 'apellidos' })}

          {renderInput({
            label: 'RUT',
            name: 'rut',
            readOnly: campoIdentidadBloqueado('rut'),
          })}

          {renderInput({
            label: 'Celular',
            name: 'celular',
            type: 'tel',
            placeholder: '+569...',
          })}

          {renderInput({
            label: 'Teléfono de emergencia',
            name: 't_emergencia',
            type: 'tel',
            placeholder: '+569...',
          })}

          {/* Correo */}
          <div className="col-span-1 md:col-span-2">
            <label className="text-sm font-semibold text-[#0A1440] mb-1 block">
              Correo electrónico
            </label>
            <input
              type="email"
              readOnly
              value={formulario.correo}
              className="w-full px-4 py-3 rounded-xl bg-gray-100 border border-gray-200 text-gray-500"
            />
          </div>
        </form>

        {/* BOTONES */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          {modoEdicion ? (
            <>
              <button
                onClick={handleSubmit}
                className="bg-[#3A6AFF] hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl"
              >
                Guardar cambios
              </button>

              <button
                onClick={handleCancelar}
                className="bg-gray-600 hover:bg-gray-700 text-white font-semibold px-6 py-3 rounded-xl"
              >
                Cancelar
              </button>
            </>
          ) : (
            <button
              onClick={() => setModoEdicion(true)}
              className="bg-[#3A6AFF] hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl"
            >
              Editar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Perfil;
